import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import styled from "styled-components";
export var BaseSVG = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: middle;\n"])));
export var SVG = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  /* stylelint-disable value-keyword-case */\n  stroke: currentColor;\n  fill: currentColor;\n"])), BaseSVG);